export default "__VITE_ASSET__DQFLbs_z__"